// Single source of truth for board member tier branding, used anywhere
// Platinum/Gold/Silver need a consistent color (member type picker, scheduler
// round selector, preference locks, draft log) instead of ad hoc hex values.
export const TIER_COLORS = {
  platinum: "#7c3aed",
  gold: "#d97706",
  silver: "#6b7280",
  // Gold + Silver now interview together as one combined scheduler round
  // (the draft itself still logs picks separately as gold/silver above).
  goldsilver: "#b45309",
};

export const TIER_LABELS = {
  platinum: "Platinum",
  gold: "Gold",
  silver: "Silver",
  goldsilver: "Gold + Silver",
};

export const TIERS = ["platinum", "gold", "silver"];
